import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import Button from 'shared/components/misc/button.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { ButtonGroup } from 'bootstrap';
import Dropdown from 'shared/components/menus/dropDown';
import { Map, OrderedMap } from 'immutable';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';
import EventShowListStore from 'flux/stores/EventShowListStore';
import UserSessionStore from 'flux/stores/UserSessionStore';

export default React.createClass({
  displayName: 'TrackingModeToggler',

  mixins: [
    Reflux.connect(FullScreenCuesheetStore, 'cuesheet'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(EventShowListStore, 'shows', (state) =>
      state.get('shows'),
    ),
  ],

  propTypes: {
    users: React.PropTypes.object.isRequired, //OrderedMap
    onChange: React.PropTypes.func.isRequired,
    onToggleTrackingEnabled: React.PropTypes.func,
    activeUser: React.PropTypes.string,
    activeId: React.PropTypes.string,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      toggleLeftValue: 'On',
      disableTracking: false,
    };
  },

  render() {
    const leftValue = this.props.toggleLeftValue ? 'ON' : 'OFF';
    let { toggleLeftValue, disableTracking, users } = this.props;

    if (users.size < 1) disableTracking = true;

    return (
      <div
        className={classNames('cs-tracking-switcher', {
          'cs-tracking-switcher-disabled': disableTracking === true,
        })}
      >
        <ButtonGroup>
          <Button
            className={classNames('btn-cs-tracking-toggle', {
              'btn-cs-tracking-toggle-on': toggleLeftValue === true,
            })}
            onClick={this._handleTrackingSwitchClick}
          >
            {leftValue}
          </Button>
          <Dropdown
            testId="showcaller-dropdown"
            itemTestId="showcaller-dropdown-item"
            dropup
            config={this._getConfig()}
          />
        </ButtonGroup>
      </div>
    );
  },

  _getConfig() {
    const { users, activeUser } = this.props;
    const { user } = this.state;
    let { iconRight } = this.props;

    const filteredUsers = users.filter(
      (showcaller) => showcaller.get('_id') !== user.get('_id'),
    );

    const trackedUser = filteredUsers.get(activeUser);
    let content = trackedUser ? (
      <span>
        <span className="dropdown-prefix">TRACKING: </span>
        <span className="showcaller-name">
          {trackedUser.get('firstName') + ' ' + trackedUser.get('lastName')}
        </span>
      </span>
    ) : (
      'Select a Show Caller to track'
    );

    let noCaret = !!iconRight;

    if (users.size < 1) {
      content = 'No other Showcallers available to track';
      noCaret = true;
      iconRight = false;
    }

    return Map({
      noCaret,
      iconRight,
      content,
      items: this._getOrderedMapOfItems(filteredUsers),
    });
  },

  _getOrderedMapOfItems(users) {
    const { eventId, showId } = this.context.router.state.params;

    const { shows } = this.state;

    let items = OrderedMap();

    users.forEach((user, userId) => {
      let hasActiveTrackingState;
      let trackingInCurrentShow;
      let show;

      if (user.hasIn(['trackableState', eventId])) {
        const trackedShowId = user.getIn(['trackableState', eventId, 'showId']);
        hasActiveTrackingState = true;
        trackingInCurrentShow = trackedShowId === showId;
        //The tracked showId may not be in the shows list because it
        //excludes saved, templated, and archived shows
        show = shows.get(trackedShowId) || null;
      }

      const trackingInInactiveShow = !show && hasActiveTrackingState;

      //1. Tracking in current show
      let content = user.get('firstName') + ' ' + user.get('lastName');

      //2. tracking in different show
      if (show && !trackingInCurrentShow) {
        const message = `This user is tracking in `;
        content = (
          <ShowCallerItem
            content={content}
            message={message}
            show={show.get('title')}
          />
        );
      }

      //3. tracking in inactive show
      if (trackingInInactiveShow) {
        const message = 'This user is not tracking in an active show';
        content = <ShowCallerItem content={content} message={message} />;
      }

      //4. doesnt have a tracking state
      if (!hasActiveTrackingState) {
        const message = 'This user is not actively tracking';
        content = <ShowCallerItem content={content} message={message} />;
      }

      items = items.set(
        userId,
        Map({
          type: 'link',
          content,
          onClick: () => this._handleSelection(userId),
        }),
      );
    });

    return items;
  },

  _handleSelection(id) {
    const {
      onChange,
      toggleLeftValue,
      onChangeOverride,
      onToggleTrackingEnabled,
    } = this.props;

    onChange(id);

    if (toggleLeftValue === true || onChangeOverride) return null;

    onToggleTrackingEnabled();
  },

  _handleTrackingSwitchClick() {
    const { onToggleTrackingEnabled } = this.props;

    onToggleTrackingEnabled();
  },
});

// eslint-disable-next-line react/prop-types
const ShowCallerItem = ({ content, message, show }) => {
  const showTitleNode = show ? <div className="show-title">{show}</div> : null;

  return (
    <div>
      <div>{content}</div>
      <div className="warning-wrapper">
        <Icon name="exclamation-triangle" />
        <div className="text-wrapper">
          <div className="warning-text">{message}</div>
          {showTitleNode}
        </div>
      </div>
    </div>
  );
};
